import $store from '../store'

class ThemeManager {

  ApplyThemeSettings (ccode, vuetify) {
		return new Promise((resolve, reject) => {
      $store.dispatch('appSettings/fetchLandingSettings', { customerCode: ccode }).then(res => {
				if (res?.themeSettings?.colors?.landing_Color1) {
					vuetify.theme.themes['light'].primary = res.themeSettings?.colors.landing_Color1
					vuetify.theme.themes['dark'].primary = res.themeSettings?.colors.landing_Color1
				}
				if (res?.themeSettings?.colors?.landing_Color2) {
					vuetify.theme.themes['light'].secondary = res.themeSettings?.colors.landing_Color2
					vuetify.theme.themes['dark'].secondary = res.themeSettings?.colors.landing_Color2
				}
				if (res?.themeSettings?.colors?.landing_Color3) {
					vuetify.theme.themes['light'].thirdly = res.themeSettings?.colors.landing_Color3
					vuetify.theme.themes['dark'].thirdly = res.themeSettings?.colors.landing_Color3
				}
				resolve()
			})
			.catch(err => reject(err))
		})
	}
}

export default new ThemeManager()
